export default __webpack_public_path__ + "static/media/grid4.e927c251.png";